import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { DropdownToggle } from "reactstrap"

const CSelectButton = ({ value, isMulti, onChange, isOpen, placeholder = "Select..." }) => {

  const ArrowRotate = expanded => {
    return (
      <svg
        height="20"
        width="20"
        viewBox="0 0 20 20"
        aria-hidden="true"
        focusable="false"
        fill="#495057"
        transform={
          expanded ? "rotate(180,0,0)" : "rotate(0,0,0)"
        }
        style={{ transition: "all 0.2s ease" }}
      >
        <path
          d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
      </svg>
    )
  }
  const getTitle = (value) => {
    // console.log({isMulti, value})
    if (!value) return placeholder
    if (!isMulti) {
      return value?.label || placeholder
    }

    if (value.length > 0) {
      return value[0]?.label || placeholder
    } else {
      return placeholder
    }

  }

  const title = getTitle(value)

  const handleDeleteItem = () => {
    try {
      onChange(value.slice(1))
    } catch (e) { console.error(e) }
  }


  return (
    <CSelectButtonStyled className="" caret outline>
      {(!isMulti || title === placeholder)
        ? <span>{title}</span>
        : <div className="d-inline-flex align-items-center justify-content-between">
          <span className="cselect-multiple">
            <div className="cselect-multiple__title">{title}</div>
            <div className="cselect-multiple__clear"onClick={handleDeleteItem}>
              <svg height="14" width="14" viewBox="0 0 20 20" className="DefaultMultipleSelect_icon__29u3w"><path
                d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" /></svg>
            </div>
          </span>
          {value?.length > 1 && <span className="all-selected-count">+{value.length - 1}</span>}
        </div>
      }
      {ArrowRotate(isOpen)}
    </CSelectButtonStyled>
  )
}

CSelectButton.propTypes = {
  isMulti: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.any,
  isOpen: PropTypes.bool,
  placeholder: PropTypes.string
}

const CSelectButtonStyled = styled(DropdownToggle)`
  &, &:hover {
    cursor: default;
    //color: rgb(73, 80, 87)
    color: var(--bs-body-color);
    //color: rgb(116, 120, 141);
    height: 38px;
    outline: 0;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(204, 204, 204);
    border-radius: 4px;
    //box-shadow: none !important;
    margin-right: 10px;
    padding: 0 7px 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    span {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    & > span {
      calc(100% - 30px);
    }

    & > div {
      max-width: calc(100% - 55px);

      .cselect-multiple {
        background-color: #e6e6e6;
        border-radius: 2px;
        display: flex;
        ////margin: 2px;
        //max-width: 140px;

        .cselect-multiple__title {
          border-radius: 2px;
          color: #333333;
          font-size: 85%;
          padding: 3px 3px 3px 6px;
          box-sizing: border-box;
          max-width: 130px;
          -webkit-user-select: none;
          user-select: none;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .cselect-multiple__clear {
          align-items: center;
          border-radius: 2px;
          display: flex;
          padding-left: 4px;
          padding-right: 4px;
          box-sizing: border-box;
          transition: 0.1ms !important;
          z-index: 3;
          -webkit-user-select: none;
          user-select: none;

          &:hover {
            background-color: #ffbdad;
            transition: 0.1ms !important;
            z-index: 3;
            cursor: pointer;

            path {
              fill: #de350b;
              transition: 0.1ms !important;
              z-index: 3;
            }
          }
        }
      }
    }

    .all-selected-count {
      position: absolute;
      right: 26px;
      width: auto;
      height: auto;
      padding: 0 5px;
      background-color: #e6e6e6;
      border-radius: 15px;
      user-select: none;
    }
  }

  &:focus {
    box-shadow: #4285f4 0 0 0 1px;
    border-color: #4285f4;
  }
`

export default (CSelectButton)
